import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkStatus, composeAuth, AuthError } from "../../helpers/utils";
import { logoutUser } from "../actions/account";

export const getUserNavigation = createAsyncThunk(
  "profile/getUserNavigation",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/navigations/institution/${payload?.institutionId}`;
      const res = await fetch(url, {
        method: "GET",
        signal: thunkApi.signal,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData?.data;
    } catch (err) {
      if (err instanceof AuthError && !thunkApi.signal.aborted && thunkApi.getState().account.jwt === payload.jwt) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  },
  {
    condition: (payload, { getState }) => {
      const state = getState();
      const scope = JSON.stringify([payload?.jwt, payload?.institutionId]);
      return Boolean(payload?.jwt && payload?.institutionId) && state.account.jwt === payload.jwt &&
        !(state.navigation.isLoadingUserNavigation && state.navigation.navigationScope === scope);
    },
  }
);
